export const SET_ALERT = 'app/dialog/SET_ALERT';
export const SET_CONFIRMATION = 'app/dialog/SET_CONFIRMATION';
